import React from 'react';
import { Button, Drawer, Typography } from 'antd';
import '../../../styles/components/MarketPlace/MarketplaceModals.scss';
import { getClientIcon } from '../../../utils/MarketplaceUtils';
import { Routes } from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import { useTranslation } from 'react-i18next';

const {Text} = Typography;

function GetStarted({open, close, jobData, siId}) {
    const clientIcon = getClientIcon(jobData?.companyName);
    const {t} = useTranslation();

    const moveToApplicationStatus = () => {
        const route = {
            pathname: Routes.APPLICATION_STATUS,
            search: `applicationId=${siId}&city=${localStorage.getItem("preferredLocation")}`,
          };
        Navigation.push(route);
    };

  return (
    <div className='drawer-container'>
        <Drawer
          open={open}
          onClose={close}
          key="getStarted"
          placement="bottom"
          closable={false}
          height="auto" 
          style={{borderRadius:'24px 24px 0px 0px'}}
        >
          <div className='get-started-modal'>
            <img className='job-successfully-applied-image' width="180px" src="/images/thumbsup.png" alt='Job Applied Successfully'/>
            <div className='new-job-greetings'>{t('new_job_greetings')}</div>
            <div className='new-job-subtext'>{t('new_job_portal_info')}</div>
            <div className='partnership-logos'>
                <img width="60px" src="/images/mitra-main-logo.png"></img> 
                <Text className='partnership-indicator'>x</Text> 
                <img width="40px" style={{marginLeft:'8px'}} src={clientIcon}></img>
            </div>
            <Button className='get-started-button' onClick={moveToApplicationStatus}>
                <Text className='get-started-text'>{t('get_started')}</Text>
            </Button>
          </div>
        </Drawer>
    </div>
  )
}

export default GetStarted
